module.exports = __webpack_public_path__ + "img/code-magnifier.a766a4c1.svg";